import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; //@ts-check

import React from 'react';
import { withStyles, createStyles } from '@material-ui/core/styles';
import GridViewPagination from '../Pagination';
import GridViewThumbnailItem from './Item';
import GridViewNoData from '../NoData';
import GridViewLoading from '../Loading';
import GridViewError from '../Error';
import { getItemId } from '../utils';
var DEFAULT_PADDING = 16 - 4;
var THUMB_WIDTH = 190;
var THUMB_HEIGHT = 240;

var styles = function styles() {
  return createStyles({
    root: {
      position: 'relative',
      background: '#eee'
    },
    items: {
      paddingLeft: DEFAULT_PADDING,
      paddingRight: DEFAULT_PADDING,
      '& a': {
        color: 'inherit'
      }
    },
    noData: {
      marginLeft: -DEFAULT_PADDING
    }
  });
};
/**
 * @param {import('./types').GridViewThumbnailProps & import('@material-ui/core').WithStyles} props
 */


function GridViewThumbnail(_ref) {
  var classes = _ref.classes,
      config = _ref.config,
      onChangePage = _ref.onChangePage,
      onChangeItemsPerPage = _ref.onChangeItemsPerPage,
      onChangeMode = _ref.onChangeMode,
      onItemClick = _ref.onItemClick,
      onItemDoubleClick = _ref.onItemDoubleClick,
      thumbnailComponent = _ref.thumbnailComponent,
      thumbnailComponentProps = _ref.thumbnailComponentProps,
      styles = _ref.styles,
      hidePageSelector = _ref.hidePageSelector,
      hideItemsPerPage = _ref.hideItemsPerPage,
      hideModeSwitcher = _ref.hideModeSwitcher,
      style = _ref.style,
      className = _ref.className;

  var _React$useState = React.useState(1),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      scale = _React$useState2[0],
      setScale = _React$useState2[1];

  var rootRef = React.useRef(null);
  var rest = {
    style: style,
    className: className
  };
  var ItemComponent = thumbnailComponent || GridViewThumbnailItem;
  var paginationProps = {
    hidePageSelector: hidePageSelector,
    hideItemsPerPage: hideItemsPerPage,
    hideModeSwitcher: hideModeSwitcher,
    onChangeMode: onChangeMode,
    onChangeItemsPerPage: onChangeItemsPerPage,
    onChangePage: onChangePage
  };
  var containerStyles = {};
  var noDataStyles = {};

  if (styles && styles.noMarginLeft) {
    containerStyles.paddingLeft = 0;
    containerStyles.marginLeft = -DEFAULT_PADDING;
    noDataStyles.marginLeft = DEFAULT_PADDING;
  } else {
    noDataStyles.paddingTop = DEFAULT_PADDING;
    noDataStyles.marginLeft = 3;
  }

  React.useEffect(function () {
    if (!rootRef.current) return;
    var containerWidth = rootRef.current.getBoundingClientRect().width;
    if (!containerWidth) return;
    var bestCount = containerWidth / (THUMB_WIDTH + 32);
    bestCount = Math.floor(bestCount);
    var scale = containerWidth / (bestCount * (THUMB_WIDTH + 32));
    if (scale > 1.2) scale = 1.2;
    setScale(scale);
  }, [rootRef.current]);
  return React.createElement("div", Object.assign({
    className: classes.root
  }, rest), React.createElement("div", {
    className: classes.items,
    style: containerStyles,
    ref: rootRef
  }, config.data.map(function (item, itemIdx) {
    var size = {
      width: THUMB_WIDTH * scale,
      height: THUMB_HEIGHT * scale
    };
    var itemId = getItemId(item, config.idKeyProp, itemIdx);
    return React.createElement(ItemComponent, Object.assign({
      key: itemId,
      config: config,
      item: item,
      onClick: onItemClick,
      onDoubleClick: onItemDoubleClick,
      elevation: styles.elevation
    }, size, thumbnailComponentProps));
  }), !config.view.isLoading && !config.data.length && React.createElement(GridViewNoData, {
    className: classes.noData,
    style: noDataStyles
  })), React.createElement(GridViewPagination, Object.assign({
    page: config.view.page,
    itemsPerPage: config.view.itemsPerPage,
    count: config.count,
    mode: config.view.mode
  }, paginationProps)), React.createElement(GridViewLoading, {
    isLoading: config.view.isLoading
  }), config.view.error && React.createElement(GridViewError, {
    error: config.view.error
  }));
}

GridViewThumbnail.defaultProps = {
  thumbnailComponentProps: {}
};
export default withStyles(styles, {
  name: 'ECGridViewThumbnail'
})(GridViewThumbnail);